import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import SystemLibrary from './pages/SystemLibrary';
import Checkout from './pages/Checkout';
import Success from './pages/Success';
import MachineLearningAI from './pages/MachineLearningAI';
import AiChatbot from './pages/AiChatbot';
import Disclaimer from './pages/Disclaimer';
import Login from './pages/Login';
import Register from './pages/Register';
import Account from './pages/Account';
import AccountSettings from './pages/AccountSettings';
import AccountBilling from './pages/AccountBilling';
import Blog from './pages/Blog';
import BlogAdmin from './pages/BlogAdmin';
import BlogEdit from './pages/BlogEdit';
import TradeIdeas from './pages/TradeIdeas';
import TradeIdeasAdmin from './pages/TradeIdeasAdmin';
import TradeIdeasEdit from './pages/TradeIdeasEdit';
import StorageTest from './pages/StorageTest';
import reportWebVitals from './reportWebVitals';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { AuthProvider } from './contexts/AuthContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import ProtectedRoute from './components/ProtectedRoute';
import MemberRoute from './components/MemberRoute';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CurrencyProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/system-library" element={<SystemLibrary />} />
          <Route path="/ai-ml" element={<MachineLearningAI />} />
          <Route
            path="/ai-chatbot"
            element={
              <MemberRoute>
                <AiChatbot />
              </MemberRoute>
            }
          />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success" element={<Success />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/settings"
            element={
              <ProtectedRoute>
                <AccountSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account/billing"
            element={
              <ProtectedRoute>
                <AccountBilling />
              </ProtectedRoute>
            }
          />
          <Route path="/blog" element={<Blog />} />
          <Route
            path="/blog/admin"
            element={
              <ProtectedRoute>
                <BlogAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blog/edit/:id"
            element={
              <ProtectedRoute>
                <BlogEdit />
              </ProtectedRoute>
            }
          />
          <Route path="/trade-ideas" element={<TradeIdeas />} />
          <Route
            path="/trade-ideas/admin"
            element={
              <ProtectedRoute>
                <TradeIdeasAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trade-ideas/edit/:id"
            element={
              <ProtectedRoute>
                <TradeIdeasEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/storage-test"
            element={
              <ProtectedRoute>
                <StorageTest />
              </ProtectedRoute>
            }
          />
        </Routes>
        </BrowserRouter>
      </CurrencyProvider>
    </AuthProvider>
    <SpeedInsights />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
